// extracted by mini-css-extract-plugin
module.exports = {"giftSection":"Gift_giftSection__XDbIO","subtitle":"Gift_subtitle__1r5Ps"};